import React, { useEffect, useState } from 'react';
import { BoxWrapper } from '../../../style';
import congratulations from "../../../images/congratulations.gif";
import { useNavigate } from 'react-router-dom';
import { getStorage } from '../../../Utils/common';
import { Helmet } from 'react-helmet';


function ThankYou() {
  const navigate = useNavigate();
  const [progressBar, setProgressBar] = useState(getStorage('percent'));
  const utm_source = getStorage('utm_source');

 
  useEffect(() => {
    if (utm_source === 'INTEXM_MEDIA_GA') {
      const gtag_report_conversion = (url) => {
        const callback = () => {
          if (typeof url !== 'undefined') {
            window.location = url;
          }
          
        };
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'conversion', {
            send_to: 'AW-17055038703/TwYOCPnM7dEaEO_5vMQ_',
            event_callback: callback,
          });
        }
      };
      gtag_report_conversion();
    }
  }, [utm_source]);
  


  return (
    <>

    <div>
      
      <BoxWrapper className="w100 gray">
        <div
          className="formmainBox flex"
          style={{
            backgroundImage: `url(${congratulations})`,
            backgroundSize: 'cover',
            height: '615px',
            width: '100%',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        >
          <div className="left">
            {/* Any other content you want to show */}
          </div>
        </div>
      </BoxWrapper>
    </div>
    </>
  );
}

export default ThankYou;
